import { ModalFlexDiscount } from '@/components';
import { createContext, useContext, useState, ReactNode } from 'react';
import { PackagesTypesProps, PriceProductProps, ProductProps, TaxSubstitutionProps } from '@/types';


type OpenModalProps = {
  product: ProductProps;
  pack: PackagesTypesProps;
  packQuantity: number;
  price: PriceProductProps;
  substTrib: TaxSubstitutionProps[];
  hasStock: boolean;
  rawQuantity: number;
}

const ModalFlexContext = createContext<{
  openModal: (props: OpenModalProps) => void;
  closeModal: (val: boolean) => void;
} | undefined>(undefined);

export const ModalFlexProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [packQuantity, setPackQuantity] = useState<number>(0);
  const [pack, setPackage] = useState<PackagesTypesProps | null>(null);
  const [product, setProduct] = useState<ProductProps | null>(null);
  const [substTrib, setSubstTrib] = useState<TaxSubstitutionProps[]>([]);
  const [hasStock, setHasStock] = useState<boolean>(false);
  const [rawQuantity, setRawQuantity] = useState<number>(0);

  const closeModal = () => {
    setPackage(null);
    setPackQuantity(0);
    setProduct(null);
    setSubstTrib([]);
    setHasStock(false);
    setRawQuantity(0);
    setIsOpen(false);
  };

  const openModal = ({product, pack, packQuantity, substTrib, hasStock, rawQuantity}: OpenModalProps) => {
    setPackage(pack);
    setPackQuantity(packQuantity);
    setProduct(product);
    setSubstTrib(substTrib);
    setHasStock(hasStock);
    setRawQuantity(rawQuantity);
    setIsOpen(true);
  };

  return (
    <ModalFlexContext.Provider value={{ openModal, closeModal }}>
      <ModalFlexDiscount
        pack={pack}
        isOpenedModal={isOpen}
        packQty={packQuantity}
        openModal={closeModal}
        setPackage={setPackage}
        substTrib={substTrib || []}
        setPackQuantity={setPackQuantity}
        product={product || {} as ProductProps}
        hasStock={hasStock || Math.floor(rawQuantity / packQuantity) > 0}
      />

      {children}
    </ModalFlexContext.Provider>
  );
};

export const useModalFlex = () => {
  const context = useContext(ModalFlexContext);

  if (!context) {
    throw new Error('O useModalFlex deve ser usado dentro de um ModalFlexProvider');
  }

  return context;
};
